import { useCountdown } from "../../shared/hooks/use-countdown";
import type { SectionRenderProps } from "../renderer/types";

export function CountdownSection({ data, copy }: SectionRenderProps) {
  const value = useCountdown(data.countdown.targetDate);
  if (!data.countdown.enabled || !data.countdown.targetDate) return null;
  const event = data.events.find((item) => item.id === data.countdown.eventId);
  return (
    <section className="countdown band" id="countdown">
      <div className="section-inner">
        <p className="eyebrow">{copy.countdown} {event?.title || "Wedding Day"}</p>
        <div className="timer" aria-live="polite">
          {([[value.days, copy.days], [value.hours, copy.hours], [value.minutes, copy.minutes], [value.seconds, copy.seconds]] as const).map(([number, label]) => (
            <div key={label}><strong>{number}</strong><span>{label}</span></div>
          ))}
        </div>
      </div>
    </section>
  );
}
